<template>
    <!--
        Single source of truth for the platform Terms of Use is the versioned
        markdown at resources/legal/tos-{version}.md, rendered server-side via
        LegalDocuments service. The HTML is passed as a `terms` prop from the
        controller (or falls back to a "terms not loaded" message if the parent
        forgot to pass it).
    -->
    <div v-if="terms" v-html="terms" class="prose prose-sm max-w-none"></div>
    <p v-else class="text-sm text-red-600">
        Terms of Use document failed to load. Please refresh the page or contact support.
    </p>
</template>

<script>
export default {
    name: 'TermsAndConditionsContent',
    props: {
        terms: {
            type: String,
            default: null,
        },
    },
}
</script>
